import { Injectable, inject } from '@angular/core';
import { AnalyticsEventName, AnalyticsService } from '@lite-workspace/shared/services/analytics';

@Injectable({ providedIn: 'root' })
export class AuthAnalyticsService {
  private readonly analytics = inject(AnalyticsService);

  coordinatorLogin(input: { projectId: string }): void {
    this.analytics.setGlobalProperties({ role: 'coordinator' });
    this.analytics.track(AnalyticsEventName.AUTH_COORDINATOR_LOGIN, { project_id: input.projectId });
  }

  clear(): void {
    this.analytics.clear();
  }
}
